<template>
    <div class="container text-start">
      <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่รับเข้าห้องแล็บ">
        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model="statusShowAll">
        <label class="form-check-label" for="inlineCheckbox1"><b>แสดงรายการย่อยทั้งหมด</b> </label>
      </div>
    </div>
    <div class="container" v-if="show">
            <table id="myRepPatTestTable" class="table table-dark table-hover table-sm" style="width: 100%;">
                <thead class="">
                <tr>
                    <th style="width:20px;">View</th>
                    <th>รหัส</th>
                    <th>ชื่อชุดตรวจ</th>
                    <th>จำนวนครั้ง</th>
                    <!-- <th>Action</th> -->
                </tr>
                </thead>
                <tbody>
                  <template v-for="item in datalists2" :key="item.TestCode">
                    <tr @click="tableChanged(item)">
                        <td class=""><button class="btn btn-sm py-0 btn-success" @click="showHideRO(item)"> <i class="fa fa-angle-right"></i></button></td>
                        <td class="">{{ item.TestCode }}</td>
                        <td class="text-start">{{ item.TestName }}</td>
                        <td class="text-start">{{ item.FreqTimes }}</td>
                        <!-- <td class=""><button class="btn btn-sm py-0 btn-warning">พิมพ์</button></td> -->
                    </tr>
                    <tr v-show="curTestID == item.TestID || statusShowAll">
                      <td colspan="4">
                        <RepPatSummary3PatTestROList
                          :show="true"
                          :branchID="branchID"
                          :dateFm="dateFm" :dateTo="dateTo"
                          :patID="patID"
                          :testID="item.TestID"></RepPatSummary3PatTestROList>
                      </td>
                    </tr>
                  </template>
                </tbody>
            </table>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import RepPatSummary3PatTestROList from './RepPatSummary3PatTestROList.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepPatSummary2',
  components: {
    RepPatSummary3PatTestROList
  },
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],

      curTestID: 0,
      statusShowAll: false
    }
  },
  // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
  props: ['show', 'datalists2', 'branchID', 'dateFm', 'dateTo', 'patID'],
  created () {
    // Initial Value
  },
  mounted () {
  },
  methods: {
    tableChanged (row) {
      this.curTestID = row.TestID
    }
  }
}
</script>

<style>

</style>
